import React from 'react';
import logo from '../assets/translation.png'
import govlogo from '../assets/governor-building-icon.svg'
import filelogo from '../assets/email-mail-sent-icon.svg'
import checklogo from '../assets/documents-search-icon.svg'
import editlogo from '../assets/language-icon.svg'
import previewlogo from '../assets/eye-icon.svg'
import approvedlogo from '../assets/indexing-pages-icon.svg'
import signaturelogo from '../assets/legal-agreement-contract-paper-icon.svg'
import { useTranslation } from 'react-i18next';

function TranslationServices() {
  const { t } = useTranslation();

  return (
    <section 
      id='translations'
      style={{
        backgroundColor: '#fff',
        padding: '3rem',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        color: '#666',
        textAlign: 'justify',
        maxWidth: 'auto'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto'}}>
        <h2 style={{ textAlign: 'center', color: 'black', marginBottom: '2rem'}}>
          {t("translationTitle")}
        </h2>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5'}}>
          {t("translationText")}
        </p>

        <div style={{ textAlign: 'center'}}>
          <img src={logo} alt="Logo" style={{ width: '5rem', height: '5rem', margin: '2rem'}}/>
        </div>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'left', marginTop: '3rem', marginBottom: '3rem'}}>
          {t("translation0")}
        </p>
        
        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          1 - {t("translation1")}
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={govlogo} alt="Logo" style={{ width: '4rem', height: '4rem', margin: '2rem'}}/>
        </div>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          2 - {t("translation2")}
          <a href="mailto:amilangues@icloud.com" style={{marginInlineStart: '1rem', textDecoration: 'none', color: 'black'}}>✉️</a>
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={filelogo} alt="Logo" style={{ width: '3rem', height: '3rem', margin: '2rem'}}/>
        </div>
        
        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          3 - {t("translation3")}
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={checklogo} alt="Logo" style={{ width: '2.5rem', height: '2.5rem', margin: '2rem'}}/>
        </div>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          4 - {t("translation4")}
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={editlogo} alt="Logo" style={{ width: '3rem', height: '3rem', margin: '2rem'}}/>
        </div>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          5 - {t("translation5")}
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={previewlogo} alt="Logo" style={{ width: '2rem', height: '2rem', margin: '2rem'}}/>
        </div>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          6 - {t("translation6")}
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={approvedlogo} alt="Logo" style={{ width: '2.5rem', height: '2.5rem', margin: '2rem'}}/>
        </div>

        <p style={{ margin: '0 auto', fontSize: '1.1rem', lineHeight: '1.5', textAlign: 'center'}}>
          7 - {t("translation7")}
        </p>
        <div style={{ textAlign: 'center'}}>
          <img src={signaturelogo} alt="Logo" style={{ width: '3rem', height: '3rem', margin: '2rem'}}/>
        </div>
      </div>
    </section>
  );
}

export default TranslationServices;